// extracted by mini-css-extract-plugin
export default {"button":"Ox5TQA","downloadIcon":"jN7Ni9"};